module.exports = __webpack_public_path__ + "img/weather.093a6062.png";